module.exports = __webpack_public_path__ + "63225acf3ca3d1baee4d7f26dc8c9552.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/containers/StaticPage/ComeBack/assets/sec-5/reviews-section-5/review-4.jpg
// module id = ./app/containers/StaticPage/ComeBack/assets/sec-5/reviews-section-5/review-4.jpg
// module chunks = 40